export default (state = {}, action = {}) => {
	if (action.type === 'LISTING') {
		if (action.listing === 'style' && action?.data?.content) {
			const lookup = {};
			action.data.content.forEach((item, i) => {
				item.sections.forEach((section) => {
					if (section?.ccBlocksImageHotspot?.content) {
						section.ccBlocksImageHotspot.content.forEach((content) => {
							if (content?.ccBlocksImageHotspotPin?.content) {
								content.ccBlocksImageHotspotPin.content.forEach((pin) => {
									if (pin?.acfProducts?.content?.individual) {
										pin.acfProducts.content.individual.forEach((product) => {
											if (!lookup[product]) lookup[product] = [];
											lookup[product].push(i);
										});
									}
								});
							}
						});
					}
				});
			});

			return {
				...state,
				[`${action.listing}Lookup`]: lookup,
				[action.listing]: {
					...action.data,
				},
			};
		}

		return {
			...state,
			[action.listing]: {
				...action.data,
			},
		};
	}
	return state;
};
